import React from 'react';

import Layout from '../../components/Layout';
import Header from '../../components/Header';
import Navigation from '../../components/Navigation';
import { AIAgent, AIAgentThreadList, AIAgentProvider } from '../../components/AIAgent';

const AIAgentPage = () => {
  return (
    <AIAgentProvider>
      <Layout>
        <Layout.TopBar>
          <Header />
        </Layout.TopBar>
        <Layout.Body>
          <Layout.SideBar>
            <Navigation />
          </Layout.SideBar>
          <Layout.List>
            <AIAgentThreadList />
          </Layout.List>
          <Layout.Content>
            <AIAgent />
          </Layout.Content>
        </Layout.Body>
      </Layout>
    </AIAgentProvider>
  );
};

export default AIAgentPage;
